import { css } from 'styled-components';

const createBreakpoint = (breakpoint, styles) => (
  css`@media (min-width: ${breakpoint}) {
    ${styles}
  }`
);

export default createBreakpoint;
